<template>

  <Head title="Recover Password" />
  <div class="hold-transition login-page">
    <div class="login-box">
      <div class="card card-outline card-primary">
        <div class="card-header text-center">
          <a href="#" class="h1"><b>KUNJUNGAN</b></a>
        </div>
        <div class="card-body">
          <div v-if="errors.email" class="alert alert-danger text-center">{{ errors.email }}</div>
          <p class="login-box-msg">Anda hanya selangkah lagi, ketikkan kata sandi baru Anda sekarang.
          </p>
          <form @submit.prevent="submit">
            <input-group placeholder="Sandi" class="fas fa-lock" v-model="form.password" :error="form.errors.password"
              type="password" />
            <input-group placeholder="Ulangi Sandi" class="fas fa-lock" v-model="form.password_confirmation"
              :error="form.errors.password_confirmation" type="password" />
            <div class="row">
              <div class="col-12">
                <button type="submit" class="btn btn-primary btn-block" :disabled="form.processing">Ganti kata sandi</button>
              </div>

            </div>
          </form>
          <p class="mt-3 mb-1">
            <a href="/login">Login</a>
          </p>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { Head } from '@inertiajs/vue3'
import InputGroup from '@/Forms/InputGroup'

export default {
  components: {
    Head,
    InputGroup,
  },
  props: {
    user: Object,
    token: String,
    errors: Object,
  },
  data() {
    return {
      form: this.$inertia.form({
        password: null,
        password_confirmation: null,
        token: this.token,
        email: this.user.email,
      }),
    }
  },
  methods: {
    submit() {
      this.form.post('/reset-password')
    },
  },
}
</script>

<style>
.login-page {
  /* The image used */
  /* background-image: url("/background.jpg"); */
  background: rgba(0, 0, 0, .65) url("/default/background.jpg");
  background-blend-mode: darken;

  /* Control the height of the image */
  min-height: 380px;

  /* Center and scale the image nicely */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
}
</style>
